import React from 'react';
import { Box, Fade, useMediaQuery, useTheme } from '@material-ui/core';
import { useParams } from 'react-router';
import Routes from 'routes';
import { LoginParams } from 'globals/types';
import { loginInitialStep as loginLocales } from 'globals/locales/registration';
import defaultLocales from 'globals/locales/default';
import FsBody from 'ui-elements/typography/FsBody';
import FsLink from 'ui-elements/links/FsLink';
import {
  FsHello,
  FsHelloWrapperBox,
  FsCenterBoxLine,
  FsCenterBoxSubTitle,
  FsCenterBoxTitle,
} from 'ui-elements/center-box-elements/FsCenterBoxElements.style-elements';
import FsLoginForm from 'ui-elements/forms/FsLoginForm';
import FsAlert from 'ui-elements/alerts/FsAlert';

import { NotificationBox, WrapperBox } from './LoginInitialStep.style-elements';

interface LoginProps {
  onGoNext?: () => void;
}

const LoginInitialStep: React.FC<LoginProps> = ({ onGoNext }) => {
  const { id: idFromEmail } = useParams<LoginParams>();
  const isVerifyNotification = idFromEmail === '123';
  const theme = useTheme();
  const isUpSm = useMediaQuery(theme.breakpoints.up('sm'), {
    noSsr: true,
  });
  const paddingTop = isUpSm ? 10 : undefined;

  const handleSuccess = () => {
    if (onGoNext) onGoNext();
  };

  return (
    <WrapperBox>
      {isVerifyNotification && (
        <NotificationBox>
          <Fade in timeout={300}>
            <FsAlert severity="success" style={{ paddingTop }}>
              {loginLocales.notifications.successVerification}
            </FsAlert>
          </Fade>
        </NotificationBox>
      )}
      <FsHelloWrapperBox>
        <FsHello>{loginLocales.hello}</FsHello>
      </FsHelloWrapperBox>
      <FsCenterBoxTitle>{loginLocales.title}</FsCenterBoxTitle>
      <FsCenterBoxSubTitle>{loginLocales.subTitle}</FsCenterBoxSubTitle>
      <FsCenterBoxLine />
      <Box marginTop={3}>
        <FsLoginForm onSuccess={handleSuccess} />
      </Box>
      <Box marginTop={3}>
        <FsBody>
          {defaultLocales.signInQuestion}{' '}
          <FsLink to={Routes.REGISTER}>{defaultLocales.signIn}</FsLink>
        </FsBody>
        <FsBody>
          {defaultLocales.resetPasswordQuestion}{' '}
          <FsLink to={Routes.RESET_PASSWORD}>
            {defaultLocales.resetPassword}
          </FsLink>
        </FsBody>
      </Box>
    </WrapperBox>
  );
};

export default LoginInitialStep;
